<div class="container d-flex h-100">
    <div class="row align-self-center w-100">
        <div class="col-6 mx-auto">
            <div class="jumbotron">
                <h1 class="display-4">Kasse gesperrt</h1>
                <p class="lead">Bitte Ausweis vorhalten um Kasse freizuschalten</p>
            </div>
        </div>
    </div>
</div>